// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { SubmissionError, submit } from 'redux-form';
import { toggleModal } from '../../storage/actions/modalsActions';
import Notification from '../notification';
import CreateCustomFieldReduxForm from '../layout/reduxForm/CreateCustomField';
import validate from '../../utils/reduxForm/validate/createCustomField';
import DashboardModalShell from './DashboardModalShell';

const EditCustomFieldModal = ({
  modalState,
  toggleModal,
  submit,
}) => {
  const closeModal = () => {
    toggleModal(false, 'editCustomFieldModal');
  };

  const addCustomFieldToWorkOrder = (customFiled) => {
    if (!(modalState.type?.input.value?.length > 0)) {
      modalState.type.input.onChange([customFiled]);
    } else if (modalState.type?.index > 0 || modalState.type?.index === 0) {
      const newCustomFields = modalState.type?.input.value.map((item, index) => (
        index !== modalState.type?.index
          ? item
          : customFiled
      ));
      modalState.type.input.onChange(newCustomFields);
    } else {
      modalState.type.input.onChange([...modalState.type?.input.value, customFiled]);
    }
    closeModal();
  };

  const onSubmit = async (values, dispatch, props) => {
    const validationErrors = validate(values);
    if (Object.keys(validationErrors).length) throw new SubmissionError(validationErrors);
    if (!props.dirty) return Notification('warning', { message: 'None changes found!' });
    const {
      name,
      value,
      type,
      customFieldId,
    } = values;
    addCustomFieldToWorkOrder({
      customFieldId,
      name,
      value,
      type: type.value,
    });
    return {};
  };

  const handlerSubmit = (event) => {
    event.preventDefault();
    submit('createCustomFieldReduxForm');
  };

  return (
    <DashboardModalShell
      isOpen={!!modalState?.isOpen}
      onClose={closeModal}
      title="Edit Custom Field"
      titleId="edit-custom-field-title"
      className="dashboard-modal--custom-field"
      bodyClassName="wurqly-modal-scroll dashboard-modal-form-scroll"
      footer={(
        <>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            onClick={handlerSubmit}
          >
            Save
          </button>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--secondary"
            onClick={closeModal}
          >
            Cancel
          </button>
        </>
      )}
    >
      <CreateCustomFieldReduxForm
        enableReinitialize
        onSubmit={onSubmit}
        initialValues={modalState?.type?.field || {}}
        disabled
      />
    </DashboardModalShell>
  );
};

const mapDispatchToProps = {
  toggleModal,
  submit,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.editCustomFieldModal,
});

export default connect(mapStateToProps, mapDispatchToProps)(EditCustomFieldModal);
